import React, { useState } from 'react'
import { useContext } from 'react';
import { HexColorPicker } from 'react-colorful';
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider';

const Color = () => {
  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext);
  const [displayColorPalate, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPalate)
  }

  const handleChange = (color) => {
    setTextEditorOptions({ ...textEditorOptions, fill: color });
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  };


  return (
    <div className='editor-item color-palate'>
      <div style={{padding: '5px', background: '#fff', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', display: 'inline-block', cursor: 'pointer'}} onClick={handleClick} data-toggle="tooltip" data-placement="top" title="Color">
        <div style={{width: '30px', height: '15px', borderRadius: '5px', backgroundColor: `${textEditorOptions.fill}`}} />
      </div>
      { displayColorPalate ? 
        <div style={{position: 'absolute', zIndex: '2'}}>
          <div style={{position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px'}} onClick={ handleClose }/>
          <HexColorPicker color={textEditorOptions.fill} onChange={handleChange} />
        </div> 
        : null 
      }
    </div>
  )
}

export default Color